import * as authentication from "../../common/actions/authentication";
import * as customer from "../actions/customer.js";

import Immutable from "seamless-immutable";

const defaultState = () => {
    return Immutable({
        chainCustomer: null,
        chainId: null,
        customerId: "",
        customerName: "",
        email: "",
        logoImageFileName: "",
        mobile: "",
        mobile2: "",
        status: null,
        streetAddress: "",
        logoUrl: "",
        saving: false
    });
};

/**
 * View reducer
 * @param {Object} state
 * @param {{type: string}} action
 * @return {*}
 */
export default function(state = defaultState(), action) {
    switch(action.type) {
    case customer.SET_CUSTOMER_INFO:
        return state.merge({
            ...action.customerInfo
        });
    case customer.SET_CUSTOMER_LOGO:
        return state.merge({
            logoUrl: action.logoUrl
        });
    case customer.CONTACT_INFORMATION_SAVING:
        return state.merge({
            saving: true
        });
    case customer.CONTACT_INFORMATION_SAVED:
        return state.merge({
            saving: false,
            contact: action.contact,
            email: action.email,
            mobile: action.mobile,
            contact2: action.contact2,
            email2: action.email2,
            mobile2: action.mobile2
        });
    case customer.CONTACT_INFORMATION_FAILED:
        return state.merge({
            saving: false
        });
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}